export default __webpack_public_path__ + "static/bodySectionBg-90fb16d109fe690b3b9fbc5e8719c40b.png";